module.exports = __webpack_public_path__ + "media/images/form-drive_in-044e7938b9c4741da8a673f0d2000532.svg";